
import DropdownBgDecor from './DropdownBgDecor.vue'
export default {
  components: { DropdownBgDecor },
  props: {
    menuItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isCollapsed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      searchInput: '',
    }
  },
  computed: {
  },
  methods: {
    checkOrder() {
      this.$router.push({
        name: 'site-lang-support-querySupport-waybill',
        params: {
          site: this.$route.params.site,
          lang: this.$route.params.lang,
        },
        query: {
          No: this.searchInput,
        },
      })
    },
  },
}
